import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  card: {
    background: 'white',
    borderRadius: 16,
    aspectRatio: '5 / 2',
  },
}));
